export default "__VITE_PUBLIC_ASSET__7ae9f8ed__"